/**
 * SITE-FORMATTER.TS
 * Format site object
 */
import { Session } from "@/redux/_session.types"
import { Site } from "./site.types"
import { SiteContext } from "./site.store"
import { PhysicalRisk } from "@/entities/physical-risk/model/physical-risk.types"
import { orderBy } from "lodash"
import getColor from "@/utils/get-color.utils"

/**
 * Formatter function
 */
export function formatSite(site: Site, _session: Session, context: SiteContext): Site {
  const legacySite = site as Site & { mapPolygon?: Site["geometry"] }
  //Search risks
  const risks = orderBy(
    context.physicalRisks.filter((risk) => risk.siteIds.includes(site.id)),
    ["cValueEffective"],
    ["desc"]
  )

  //Get max risk
  const cRiskMax: PhysicalRisk | null = risks[0] ?? null

  return {
    ...site,
    geometryType: site.geometryType ?? "polygon",
    geometry: site.geometry ?? legacySite.mapPolygon ?? [],
    populationIds: site.populationIds ?? [],

    //Calculation
    cColor: cRiskMax?.cValueEffectiveColor ?? getColor("green"),
    cRiskMax
  }
}
